"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constants = require("./constants");

var _treeNodes = _interopRequireDefault(require("./components/treeNodes"));

var _select = _interopRequireDefault(require("../select"));

var _textfield = _interopRequireDefault(require("../textfield"));

var _buttonGroup = _interopRequireDefault(require("../buttonGroup"));

var _button = _interopRequireDefault(require("../button"));

var _search = _interopRequireDefault(require("../../assets/icons/search.svg"));

var _tree = _interopRequireDefault(require("../../assets/icons/tree.svg"));

var _treeDark = _interopRequireDefault(require("../../assets/icons/tree-dark.svg"));

var _list = _interopRequireDefault(require("../../assets/icons/list.svg"));

var _listDark = _interopRequireDefault(require("../../assets/icons/list-dark.svg"));

var _utils = require("./utils");

var _nodesTable = _interopRequireDefault(require("./components/nodesTable"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

(function () {
  var styles = "@font-face {\n  font-family: 'OpenSansRegular';\n  src: url(\"../assets/font/OpenSans-latin-normal.woff2\") format(\"woff2\"); }\n\n.tree-view-bounding-container {\n  position: relative;\n  height: 100%; }\n\n.tree-view-container {\n  display: inline-block;\n  height: 100%;\n  width: 100%; }\n\n.tree-view-container::-webkit-scrollbar-track {\n  background: transparent; }\n\n.tree-view-container::-webkit-scrollbar-thumb {\n  background: #c6c6c6;\n  border-radius: 0.625rem; }\n\n.tree-view-container::-webkit-scrollbar-thumb:hover {\n  background: #6f6f6f;\n  border-radius: 0.625rem; }\n\n.tree-view-filter-container {\n  margin-bottom: 1rem;\n  display: flex;\n  justify-content: space-between; }\n\n.tree-view-node-icon {\n  height: 1.25rem;\n  width: 1.25rem;\n  object-fit: contain; }\n  .tree-view-node-icon-cursor-pointer {\n    cursor: pointer; }\n\n.tree-view-filter-container-without-dropdown {\n  margin-bottom: 1rem;\n  display: flex;\n  justify-content: flex-end; }\n";
  var fileName = "compone_treeView";
  var element = document.querySelector("style[data-sass-component='compone_treeView']");

  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

var Tree = function Tree(_ref) {
  var _ref$nodes = _ref.nodes,
      nodes = _ref$nodes === void 0 ? {} : _ref$nodes,
      onChange = _ref.onChange,
      _ref$readOnly = _ref.readOnly,
      readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly,
      _ref$isSelectedDefaul = _ref.isSelectedDefault,
      isSelectedDefault = _ref$isSelectedDefaul === void 0 ? false : _ref$isSelectedDefaul,
      _ref$hideCheckboxes = _ref.hideCheckboxes,
      hideCheckboxes = _ref$hideCheckboxes === void 0 ? false : _ref$hideCheckboxes,
      _ref$hideDropdownFilt = _ref.hideDropdownFilter,
      hideDropdownFilter = _ref$hideDropdownFilt === void 0 ? false : _ref$hideDropdownFilt,
      _ref$singleSelect = _ref.singleSelect,
      singleSelect = _ref$singleSelect === void 0 ? false : _ref$singleSelect,
      _ref$singleSelectRadi = _ref.singleSelectRadio,
      singleSelectRadio = _ref$singleSelectRadi === void 0 ? false : _ref$singleSelectRadi,
      _ref$allowOnlyLeafSel = _ref.allowOnlyLeafSelection,
      allowOnlyLeafSelection = _ref$allowOnlyLeafSel === void 0 ? false : _ref$allowOnlyLeafSel,
      _ref$allowRootSelecti = _ref.allowRootSelection,
      allowRootSelection = _ref$allowRootSelecti === void 0 ? true : _ref$allowRootSelecti,
      _ref$showCreatedDate = _ref.showCreatedDate,
      showCreatedDate = _ref$showCreatedDate === void 0 ? false : _ref$showCreatedDate,
      _ref$rootLeafNodesFir = _ref.rootLeafNodesFirst,
      rootLeafNodesFirst = _ref$rootLeafNodesFir === void 0 ? false : _ref$rootLeafNodesFir;

  var _useState = (0, _react.useState)([]),
      _useState2 = _slicedToArray(_useState, 2),
      data = _useState2[0],
      setData = _useState2[1];

  var _useState3 = (0, _react.useState)(_constants.SHOW_ALL),
      _useState4 = _slicedToArray(_useState3, 2),
      filter = _useState4[0],
      setFilter = _useState4[1];

  var _useState5 = (0, _react.useState)(''),
      _useState6 = _slicedToArray(_useState5, 2),
      searchText = _useState6[0],
      setSearchText = _useState6[1];

  var _useState7 = (0, _react.useState)(_constants.TREE_VIEW),
      _useState8 = _slicedToArray(_useState7, 2),
      view = _useState8[0],
      setView = _useState8[1];

  var _useState9 = (0, _react.useState)(0),
      _useState10 = _slicedToArray(_useState9, 2),
      updateCount = _useState10[0],
      setUpdateCount = _useState10[1];

  (0, _react.useEffect)(function () {
    var flattenedTree = (0, _utils.flattenTree)(nodes);
    setData(flattenedTree);
    setUpdateCount(function (updateCount) {
      return updateCount + 1;
    });
  }, [JSON.stringify(nodes)]);
  (0, _react.useEffect)(function () {
    isSelectedDefault && setFilter(_constants.SHOW_SELECTED);
  }, [isSelectedDefault]);

  var handleCheckboxClick = function handleCheckboxClick(nodeId, isChecked) {
    var updatedNodes = (0, _utils.findAndUpdateCheckedStatus)(nodeId, isChecked, data, singleSelect);
    setData(_toConsumableArray(updatedNodes));

    if (typeof onChange === 'function') {
      onChange((0, _utils.getSelectedItems)(updatedNodes));
    }
  };

  var treeNodeProps = {
    nodes: data,
    updateCount: updateCount,
    filter: filter,
    searchText: searchText === null || searchText === void 0 ? void 0 : searchText.toLowerCase(),
    readOnly: readOnly,
    onChange: onChange,
    hideCheckboxes: hideCheckboxes,
    singleSelect: singleSelect,
    singleSelectRadio: singleSelectRadio,
    allowOnlyLeafSelection: allowOnlyLeafSelection,
    allowRootSelection: allowRootSelection,
    rootLeafNodesFirst: rootLeafNodesFirst
  };
  var tableNodeProps = {
    nodes: data,
    updateCount: updateCount,
    filter: filter,
    searchText: searchText === null || searchText === void 0 ? void 0 : searchText.toLowerCase(),
    readOnly: readOnly,
    handleCheckboxClick: handleCheckboxClick,
    hideCheckboxes: hideCheckboxes,
    singleSelect: singleSelect,
    singleSelectRadio: singleSelectRadio,
    allowOnlyLeafSelection: allowOnlyLeafSelection,
    allowRootSelection: allowRootSelection,
    showCreatedDate: showCreatedDate,
    rootLeafNodesFirst: rootLeafNodesFirst
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.TreeClass.boundingContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: hideDropdownFilter ? _constants.TreeClass.filterContainerWithoutDropdown : _constants.TreeClass.filterContainer
  }, !hideDropdownFilter && /*#__PURE__*/_react.default.createElement(_select.default, {
    width: "180px",
    options: [_constants.SHOW_ALL, _constants.SHOW_SELECTED],
    onChange: function onChange(_, value) {
      return setFilter(value);
    },
    value: filter,
    getOptionLabel: function getOptionLabel(option) {
      return option;
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'flex'
    }
  }, /*#__PURE__*/_react.default.createElement(_textfield.default, {
    width: "200px",
    type: "text",
    value: searchText,
    placeholder: "Search",
    onChange: function onChange(e) {
      return setSearchText(e.target.value);
    },
    icon: /*#__PURE__*/_react.default.createElement("img", {
      src: _search.default
    }),
    iconPosition: "left"
  }), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginLeft: '16px'
    }
  }, /*#__PURE__*/_react.default.createElement(_buttonGroup.default, {
    type: "radio",
    onClick: function onClick(value) {
      return setView(value);
    },
    size: "large",
    defaultValue: view
  }, /*#__PURE__*/_react.default.createElement(_button.default, {
    value: _constants.TABLE_VIEW,
    tooltipText: _constants.tooltipText.list
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: view === _constants.TABLE_VIEW ? _list.default : _listDark.default
  })), /*#__PURE__*/_react.default.createElement(_button.default, {
    value: _constants.TREE_VIEW,
    tooltipText: _constants.tooltipText.tree
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: view === _constants.TREE_VIEW ? _tree.default : _treeDark.default
  })))))), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.TreeClass.container,
    tabIndex: _constants.tabIndex
  }, view === _constants.TREE_VIEW ? /*#__PURE__*/_react.default.createElement(_treeNodes.default, treeNodeProps) : /*#__PURE__*/_react.default.createElement(_nodesTable.default, tableNodeProps)));
};

var recursiveShapeType = function recursiveShapeType() {
  var propsType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var recursiveKey = arguments.length > 1 ? arguments[1] : undefined;

  var type = function type() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _propTypes.default.shape(propsType).apply(null, args);
  };

  propsType[recursiveKey] = _propTypes.default.arrayOf(type);
  return type;
};

var nodeShape = {
  label: _propTypes.default.string.isRequired,
  value: _propTypes.default.string || _propTypes.default.number,
  expanded: _propTypes.default.bool,
  checked: _propTypes.default.bool,
  highlighted: _propTypes.default.bool,
  type: _propTypes.default.oneOf(['node', 'leaf']),
  leftIcon: _propTypes.default.shape({
    icon: _propTypes.default.any,
    tooltip: _propTypes.default.string,
    onClick: _propTypes.default.func
  }),
  rightIcon: _propTypes.default.shape({
    icon: _propTypes.default.any,
    tooltip: _propTypes.default.string,
    onClick: _propTypes.default.func
  })
};
Tree.propTypes = {
  nodes: _propTypes.default.shape(_objectSpread(_objectSpread({}, nodeShape), {}, {
    nodes: _propTypes.default.arrayOf(recursiveShapeType(nodeShape, _constants.recursivePropName))
  })).isRequired,
  onChange: _propTypes.default.func,
  readOnly: _propTypes.default.bool,
  hideCheckboxes: _propTypes.default.bool,
  isSelectedDefault: _propTypes.default.bool,
  hideDropdownFilter: _propTypes.default.bool,
  singleSelect: _propTypes.default.bool,
  singleSelectRadio: _propTypes.default.bool,
  allowOnlyLeafSelection: _propTypes.default.bool,
  allowRootSelection: _propTypes.default.bool,
  showCreatedDate: _propTypes.default.bool,
  rootLeafNodesFirst: _propTypes.default.bool
};
var _default = Tree;
exports.default = _default;